import { bigQuery } from '@fiverr-private/obs';
import { GROUPES, SUB_GROUPES } from '../constants';
import { getMarketplaceIntegrationBqPayload } from '../utils';

const trackLogoMakerBuyerListingShow = (briefId) => {
    const payload = {
        group: GROUPES.PAGE_VIEW,
        sub_group: SUB_GROUPES.WEBSITE_ACTION,
        type: 'logo_maker_buyer_listing_show',
        makers_project: {
            brief: {
                id: briefId,
            },
        },
    };

    bigQuery.send(getMarketplaceIntegrationBqPayload(payload));
};

export default trackLogoMakerBuyerListingShow;
